import { render, staticRenderFns } from "./ArticleSelectInput.vue?vue&type=template&id=5935ea58&scoped=true"
import script from "./ArticleSelectInput.vue?vue&type=script&lang=ts"
export * from "./ArticleSelectInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935ea58",
  null
  
)

export default component.exports